import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { VisuallyHidden } from 'shared/components';

export const Table = styled('table')(({ theme: { breakpoints, colors } }) => {
    /* Custom media queries since the mobile/desktop styling is completely different */
    const mqMobileOnly = `@media only screen and (max-width: ${
        breakpoints[0] - 1
    }px)`;
    const mqLargerThanMobile = `@media only screen and (min-width: ${breakpoints[0]}px)`;

    return css`
        border-collapse: collapse;

        td {
            vertical-align: top;
        }

        ${mqMobileOnly} {
            tr {
                display: flex;
                flex-wrap: wrap;
            }

            td {
                width: 50%;
                padding-top: 1rem;

                &:nth-of-type(2) {
                    width: 100%;
                    order: 3;
                    padding-top: 0;
                    padding-bottom: 1rem;
                    border-bottom: 1px solid ${colors['graphic-divider']};
                }

                &:last-of-type {
                    text-align: right;
                }
            }
        }

        ${mqLargerThanMobile} {
            td {
                width: 100%;
                border-bottom: 1px solid ${colors['graphic-divider']};
                padding: 1rem 0;

                &:first-of-type,
                &:last-of-type {
                    width: auto;
                    white-space: nowrap;
                }

                &:first-of-type {
                    padding-right: 3rem;
                }

                &:last-of-type {
                    padding-left: 3rem;
                }
            }
        }
    `;
});

export const TableHead = VisuallyHidden.withComponent('thead');

export const HistoryTime = styled('time')(({ theme: { colors, type } }) => {
    return css`
        line-height: ${type.lineHeight};
        font-size: ${type.body};
        color: ${colors['text-body']};
    `;
});
